import { Rectangle } from "../../domain/drawing";
import { IDocumentImageSource } from "../../domain/document";

export interface IImageErasable {
  erase(rectangle: Rectangle, scale: number, source: string, hiddenElement: HTMLElement): Promise<IDocumentImageSource>;
  registerErasingChangedHandler(handler: (isErasing: boolean) => void): void;
}

export function instanceOfIImageErasable(instance: any): instance is IImageErasable {
  return instance
      && (instance.erase !== undefined)
      && (instance.registerErasingChangedHandler !== undefined);
}
